module.exports = __webpack_public_path__ + "static/profile-988518887839a84b36196e413da177ed.png";